import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { validateAdminLoginForm } from "../utils/validators";

export default function AdminLogin() {
  const { admin, adminLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "" });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (admin) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [admin, navigate]);

  const handleChange = (field) => (event) => {
    setForm((previous) => ({ ...previous, [field]: event.target.value }));
    setErrors((previous) => ({ ...previous, [field]: "" }));
    setSubmitError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const nextErrors = validateAdminLoginForm(form);
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    const result = await adminLogin(form);
    if (!result.ok) {
      setSubmitError(result.error);
      return;
    }

    navigate("/admin/dashboard", { replace: true });
  };

  return (
    <section className="auth-page-shell">
      <form className="auth-box" onSubmit={handleSubmit} noValidate>
        <h2>Admin Login</h2>

      <input
        placeholder="Email"
        value={form.email}
        onChange={handleChange("email")}
        aria-invalid={Boolean(errors.email)}
      />
      {errors.email && <p className="input-error">{errors.email}</p>}

      {submitError && <p className="submit-error">{submitError}</p>}

        <button type="submit">Login</button>
      </form>
    </section>
  );
}
